/*
 * Innovist mobile navigation (snippets/header-inv-mobile-nav.liquid): opens
 * the 343px panel, single-open accordions, Escape / backdrop close. The panel
 * is moved to <body> on first open because #header-component uses
 * `contain: layout`, which would otherwise trap a fixed element inside it.
 */
(function () {
  if (window.invMobileNavInit) return;
  window.invMobileNavInit = true;

  var DURATION = 460;
  var closeTimer = null;

  function nav() {
    return document.getElementById('InvMobileNav');
  }

  function setTriggers(open) {
    document.querySelectorAll('.inv-mnav-trigger').forEach(function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function open() {
    var el = nav();
    if (!el) return;
    // Escape #header-component's `contain: layout` so position:fixed is viewport-relative.
    if (el.parentElement !== document.body) {
      document.querySelectorAll('body > .inv-mnav').forEach(function (old) { if (old !== el) old.remove(); });
      document.body.appendChild(el);
    }
    clearTimeout(closeTimer);
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    document.documentElement.classList.add('inv-mnav-open');
    setTriggers(true);
  }

  function close() {
    var el = nav();
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    setTriggers(false);
    closeTimer = setTimeout(function () {
      el.hidden = true;
      document.documentElement.classList.remove('inv-mnav-open');
    }, DURATION * 0.65);
  }

  function setAcc(toggle, isOpen) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.hidden = !isOpen;
    if (!isOpen) {
      panel.querySelectorAll('[data-inv-acc][aria-expanded="true"]').forEach(function (c) { setAcc(c, false); });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.inv-mnav-trigger');
    if (trigger) {
      e.preventDefault();
      var el = nav();
      if (el && el.classList.contains('is-open')) close(); else open();
      return;
    }
    if (e.target.closest('[data-inv-mnav-close]')) { close(); return; }
    // A row link that stays on this page (e.g. "/#science" on the home page)
    // would otherwise leave the panel open over the scrolled page.
    if (e.target.closest('#InvMobileNav a[href]')) { close(); return; }
    var toggle = e.target.closest('[data-inv-acc]');
    if (toggle) {
      var item = toggle.parentElement;
      var list = item.parentElement;
      var shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
      if (shouldOpen) {
        Array.prototype.forEach.call(list.children, function (sib) {
          if (sib === item) return;
          var st = sib.querySelector(':scope > [data-inv-acc][aria-expanded="true"]');
          if (st) setAcc(st, false);
        });
      }
      setAcc(toggle, shouldOpen);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Leaving the mobile layout with the panel open must not leave the page locked.
  window.matchMedia('(min-width: 769px)').addEventListener('change', function (m) {
    if (m.matches) close();
  });
})();
